import { getToken } from '../SharedCommon/utils';
import cryptoUtils from './cryptoproxy/cryptoUtil';
import { getWebSocketUrl } from './socket';

// this socket is for the whole app, not to a specific chatroom
export default class GTAppSocket {
  socket = null;
  // eslint-disable-next-line
  newMessageCallback = (data) => {};
  connectedCallback = () => {};
  disconnectedCallback = () => {};
  reconnectedCallback = () => {};

  isExplicitClose = false;
  reconnectTimer = null;
  reconnectDelay = 2000;
  hasConnectedOnce = false;

  constructor() {}

  init({ onNewMessage }) {
    if (!getToken()) {
      console.log('no init app socket');
      return;
    }
    if (typeof window !== 'undefined' && window.location && window.location.href.indexOf('appsocket=1') === -1) {
      console.log('app socket can be enabled with ?appsocket=1');
      return;
    }
    console.log('init app socket');

    this.newMessageCallback = onNewMessage;

    this.closeSocket();
    this.isExplicitClose = false;

    this.connect();
  }

  connect() {
    const url = getWebSocketUrl();
    if (!url) {
      console.log('no init app socket: missing token or URL');
      return;
    }

    console.log('app websocket connecting to:', url);

    const WebSocketImpl =
      typeof WebSocket !== 'undefined' ? WebSocket : typeof window !== 'undefined' ? window.WebSocket : null;
    if (!WebSocketImpl) {
      console.error('WebSocket is not supported in this environment');
      return;
    }

    let ws;
    try {
      ws = new WebSocketImpl(url);
    } catch (err) {
      console.error('Failed to create app WebSocket:', err);
      this.scheduleReconnect();
      return;
    }

    if (window.___appsocket && window.___appsocket !== this && typeof window.___appsocket.close === 'function') {
      try {
        window.___appsocket.close();
      } catch (e) {
        // ignore
      }
    }
    window.___appsocket = this;
    this.socket = ws;

    ws.onopen = () => {
      if (this.socket !== ws) {
        return;
      }
      console.log('app socket connected!');
      if (this.hasConnectedOnce) {
        this.reconnectedCallback();
      }
      this.hasConnectedOnce = true;
      this.reconnectDelay = 2000;
      this.connectedCallback();
    };

    ws.onmessage = (event) => {
      if (this.socket !== ws) {
        return;
      }
      try {
        let rawData = event.data;
        if (typeof rawData === 'string' && !rawData.trim().startsWith('{') && !rawData.trim().startsWith('[')) {
          try {
            rawData = cryptoUtils.decryptSession(rawData);
          } catch (e) {
            console.warn('decryptSession failed:', e);
          }
        }
        const parsed = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
        if (!parsed) {
          return;
        }

        const { event: evt, data } = parsed;

        if (evt === 'notifyMessage' || evt === 'newMessages') {
          this.onNotifyMessage(data);
        } else {
          console.log('Unhandled app websocket event:', evt, data);
        }
      } catch (err) {
        console.error('Error handling app WebSocket message:', err);
      }
    };

    ws.onerror = (error) => {
      if (this.socket !== ws) {
        return;
      }
      console.log('app socket error:', error);
    };

    ws.onclose = (event) => {
      if (this.socket !== ws) {
        return;
      }
      console.log(`app socket closed: code=${event.code}, reason=${event.reason}`);
      this.disconnectedCallback();
      if (!this.isExplicitClose && event.code !== 4001 && getToken()) {
        this.scheduleReconnect();
      }
    };
  }

  scheduleReconnect() {
    if (this.isExplicitClose || this.reconnectTimer) {
      return;
    }

    const delay = this.reconnectDelay + Math.floor(Math.random() * 1000);
    console.log(`Scheduling app WebSocket reconnect in ${delay}ms`);
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null;
      if (!this.isExplicitClose && getToken()) {
        this.connect();
      }
    }, delay);

    this.reconnectDelay = Math.min(this.reconnectDelay * 1.5, 30000);
  }

  onNotifyMessage(data) {
    console.log('app socket onNotifyMessage: ', data);
    try {
      this.newMessageCallback(data);
    } catch (error) {
      console.log('onNewMessage: ', error, data);
    }
  }

  async sendMessageAsync(data) {
    console.log('app socket sendMessage:', data);
  }

  closeSocket() {
    this.isExplicitClose = true;
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    if (this.socket) {
      const s = this.socket;
      this.socket = null;
      try {
        s.close();
      } catch (e) {
        // ignore
      }
    }
    if (window.___appsocket === this) {
      window.___appsocket = null;
    }
  }

  close() {
    this.closeSocket();
  }
}
